import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
import {Form} from "react-bootstrap";
import {Button} from "react-bootstrap";
import {Alert} from "react-bootstrap";
import DefaultLayout from "../layouts/Default";
require('odatajs');



class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          pending: false,
          data: {},
          params: props.match.params,
          showError : false
        };
      }
    componentDidMount() {
      document.title = "Login";
    }
    render() { 
        return (
<DefaultLayout>

<Form  onSubmit={(event) => {
            	event.preventDefault();
    		let token = localStorage.getItem('_TOKEN_AUTH');
                var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
                var request = {
                    requestUri: API_URL + "Users/Default.Login",
                    method: 'POST',
                    headers: headers,
                    data: this.state.data
                };
                window.odatajs.oData.request(
                    request,
                    (data, response) => {
                      
            localStorage.setItem('_TOKEN_AUTH', data.value);
            window.location.href = "/";
          
                    },
                    (err) => {
                      this.setState({error: err.message, showError:true});
                    }
                );    
          }}>
  <Form.Group>
    <Form.Label htmlFor="emailInput">Email address</Form.Label>
    <Form.Control
      type="email" id="emailInput" placeholder="Enter email"
      value={this.state.data.email} onChange={(e) => { let data = this.state.data; data.email = e.target.value; this.setState({ data });}}
      aria-describedby="emailInputHelpBlock"/>
    <Form.Text id="emailInputHelpBlock" muted>We'll never share your email with anyone else.</Form.Text>
  </Form.Group>
  <Form.Group>
    <Form.Label htmlFor="passwordInput">Password</Form.Label>
    <Form.Control
      type="password" id="passwordInput" placeholder="Password"
      value={this.state.data.password} onChange={(e) => { let data = this.state.data; data.password = e.target.value; this.setState({ data });}}
      aria-describedby="passwordInputHelpBlock"/>
    <Form.Text id="passwordInputHelpBlock" muted></Form.Text>
  </Form.Group>
<Button type="submit">Login</Button>
<Alert variant="danger" onClose={() => this.setState({showError : false})} show={this.state.showError} dismissible>
          <Alert.Heading>User Login failed</Alert.Heading>
          <p>{this.state.error}</p>
        </Alert>
 
</Form>

</DefaultLayout>
	);
    }
}
 
export default LoginPage;